import "./App.css";
import "swiper/css";
import "swiper/css/bundle";
import { Fragment, useState } from "react";
import routes from "./routes/routes";
import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LiveChat from "./Component/Shear/LiveChat/LiveChat";
import { StepsProvider } from "./lib/Context";
import reportWebVitals from "./lib/reportWebVitals";
const queryClient = new QueryClient();

function App() {
  const [loading, setLoading] = useState(true);
  const spinner = document.getElementById("spinner");

  if (spinner) {
    setTimeout(() => {
      spinner.style.display = "none";
      setLoading(false);
    }, 2000);
  }

  return (
    <Fragment>
      <StepsProvider>
        <QueryClientProvider client={queryClient}>
          {!loading && <RouterProvider router={routes} />}
          <ToastContainer />
          <LiveChat />
        </QueryClientProvider>
      </StepsProvider>
    </Fragment>
  );
}
reportWebVitals();
export default App;
